import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GlobalsStore } from '../../../stores/globals.state';
import { Topic } from '../../../models/topic';
import { Button, ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { TableRowAction } from '../table-row-indicator/table-row-indicator.component';
import { NgIf } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { RoutingService } from '../../../services/routing.service';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-table-row-topic]',
  standalone: true,
  imports: [Button, ButtonDirective, RouterLink, NgIf, TooltipModule],
  templateUrl: './table-row-topic.component.html',
  styleUrl: './table-row-topic.component.scss',
})
export class TableRowTopicComponent {
  readonly activeUserStore = inject(ActiveUserStore);
  readonly globalStore = inject(GlobalsStore);
  @Input() item!: Topic;
  @Input() actions: TableRowAction[] = [];
  @Output() closeEvent = new EventEmitter<void>();

  constructor(private routingService: RoutingService) {}

  /**
   * Closes the parent component by emitting a close event.
   *
   * @return {void} This method does not return any value.
   */
  closeParent(): void {
    this.closeEvent.emit();
  }

  /**
   * Opens the specified topic in Atlas by either triggering an event or navigating to a new tab.
   *
   * @param {Topic} item - The topic to be opened in Atlas. It must contain the necessary properties such as an identifier (_id).
   * @return {void} This method does not return a value.
   */
  openInAtlas(item: Topic): void {
    this.closeParent();
    if (this.activeUserStore.context() === 'dataBackend') {
      this.routingService.openRouteInNewTab(`/atlas-intern?topic=${item._id}`);
    } else {
      this.globalStore.triggerAtlasEvent('loadTopic', {
        topic: item,
      });
    }
  }
}
